import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import mobx, { observable, when, action, computed, transaction } from 'mobx';
import _ from 'lodash';
import form from './send-email-form';
import * as uuid from 'uuid';
import Editor from '../shared/skyckeditor';
import Notifications from '../utils/notification-helper';
import TagsInput from 'react-tagsinput';
import GoogleAPIResource from '../resources/google-api-resource';
import moment from 'moment';
import AttachedFilesComponent from './attached-files-component';
import S3DownloadButton from './s3-download-button';
import PropTypes from 'prop-types';
import EmailHelper from '../utils/email-helper';
import ConfirmModal from '../shared/confirm-modal';

const EMAIL_VALIDATION_REGEX =
    /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

class EmailModel {
    @observable toEmails = [];
    @observable ccEmails = [];
    @observable bccEmails = [];
    @observable fromEmail = '';
    @observable body = '';
    @observable subject = '';
    @observable attachments = [];

    fromJS(json) {
        Object.assign(this, json);
    }
}

class SendEmailStore {
    @observable templates = [];
    @observable emailModel = new EmailModel();
    @observable selectedTemplate;

    constructor(appStore) {
        this.appStore = appStore;
        this.googleAPIResource = new GoogleAPIResource();
    }

    @action
    setAttached(files) {
        this.emailModel.attachments.replace(files || []);
    }

    attachments() {
        // seems like there would be a better way to do this...
        return _.map(this.emailModel.attachments.slice(), (attachment) => {
            //const result = Object.assign({},attachment)
            var result = {};
            result.fileKey = attachment.fileKey;
            result.fileUrl = attachment.fileUrl;
            result.filename = attachment.filename;
            result.publicUrl = attachment.publicUrl;
            result.signedUrl = attachment.signedUrl;

            const file = {};

            file.lastModified = attachment.file.lastModified;
            file.lastModifiedDate = attachment.file.lastModifiedDate;
            file.name = attachment.file.name;
            file.preview = attachment.file.preview;
            file.size = attachment.file.size;
            file.type = attachment.file.type;
            file.webkitRelativePath = attachment.file.webkitRelativePath;
            result.file = file;
            return result;
        });
    }

    loadAndFilterTemplates(templates, tag) {
        const filteredTemplates = _.filter(templates.slice(), (template) => {
            return _.intersection(template.settings.tags, [tag]).length > 0;
        });
        this.templates.replace(filteredTemplates);
    }

    sendEmail(model) {
        return this.googleAPIResource.sendEmail(this.appStore.authStore.getAccessToken(), model);
    }
}

@inject('appStore')
@observer
export default class SendEmail extends Component {
    constructor(props) {
        super(props);
        this.sendEmailStore = new SendEmailStore(appStore);
        this.emailTemplateStore = appStore.emailTemplateStore;
        this.form = form();
        this.state = {
            missingContacts: [],
            showTemplateChangeModel: false,
            newTemplateId: null,
            isSendButtonEnabled: true,
            isSendInvoice: false,
            invoice: null,
        };

        this.readyForChanges = false;
        this.propagateChanges = false;
    }

    updateEmailModelFromTemplate(props) {
        const file = appStore.tcFileStore.selectedFile,
            propData = { toEmails: props.toEmails, ccEmails: props.ccEmails, bccEmails: props.bccEmails },
            emailData = EmailHelper.generateEmailData(
                props.appStore.tcFileStore.selectedFileContacts,
                this.sendEmailStore.selectedTemplate,
                propData
            );

        this.setState({ missingContacts: emailData.missingContacts });

        const templateData = _.defaults({}, props.extraTemplateData || {}, emailData.templateData, file);
        const renderedTemplate = this.emailTemplateStore.renderTemplate(
            this.sendEmailStore.selectedTemplate,
            templateData,
            this.emailTemplateStore.style.css
        );

        this.sendEmailStore.emailModel.toEmails = emailData.toEmails;
        this.sendEmailStore.emailModel.ccEmails = emailData.ccEmails;
        this.sendEmailStore.emailModel.bccEmails = emailData.bccEmails;
        this.sendEmailStore.emailModel.fromEmail = file.coordinator.profile.email;
        this.sendEmailStore.emailModel.subject = renderedTemplate.subject;
        this.sendEmailStore.emailModel.body = renderedTemplate.body;
    }

    updateSelectedTemplate(templateId) {
        this.sendEmailStore.selectedTemplate = this.sendEmailStore.templates.find(
            (template) => template.id === templateId
        );

        if (this.props.draftTemplateId === this.sendEmailStore.selectedTemplate.id && this.props.model) {
            this.updateEmailModelFromDraft();
            this.updateFormFromModel();
        } else {
            this.updateEmailModelFromTemplate(this.props);
            this.updateFormFromModel();
        }
    }

    updateFormFromModel() {
        _.each(mobx.toJS(this.sendEmailStore.emailModel), (value, key) => {
            if (this.form.has(key)) {
                if (key === 'toEmails' || key === 'fromEmails' || key === 'ccEmails' || key === 'bccEmails') {
                    let obj = {};
                    obj[key] = value;
                    this.form.update(obj);
                } else {
                    this.form.$(key).set(value);
                }
            }
        });
    }

    updateUI(props) {
        this.sendEmailStore.selectedTemplate = this.sendEmailStore.templates[0];
        this.updateEmailModelFromTemplate(props);
        this.updateFormFromModel();
    }

    buildEmailModelFromForm() {
        const model = this.form.values();
        model.body = CKEDITOR.instances[this.state.editorId] ? CKEDITOR.instances[this.state.editorId].getData() : '';
        model.attachments = this.sendEmailStore.attachments();
        return model;
    }

    handleFormChange() {
        if (this.props.onEmailModelChange && this.readyForChanges) {
            this.props.onEmailModelChange(this.buildEmailModelFromForm(), this.sendEmailStore.selectedTemplate.id);
        }
    }

    handleValidationError(tags) {
        /*TODO:  Show errors.*/
    }

    handleTemplateChange(e) {
        this.propagateChanges = false;
        this.updateSelectedTemplate(+e.target.value);
        this.propagateChanges = true;
    }

    handleSend() {
        this.form.validate({ showErrors: true }).then((form) => {
            if (form.isValid) {
                // this is the closest store that is in the isLoading map in appStore
                // feels like sendEmailStore would be better but it's has no association with the appStore map
                appStore.workflowStore.setLoading(true);
                this.setState({ isSendButtonEnabled: false });
                const step = this.props.step,
                    model = this.form.values();
                model.body = CKEDITOR.instances[this.state.editorId].getData();
                if (this.state.isSendInvoice && this.state.invoice) {
                    let invoiceAttachments = [];
                    invoiceAttachments.push(this.state.invoice);
                    model.attachments = invoiceAttachments;
                } else {
                    model.attachments = this.sendEmailStore.attachments();
                }
                model.sentDate = moment().format();
                let emailSent = false;
                this.sendEmailStore
                    .sendEmail(model)
                    .then(() => {
                        emailSent = true;
                        if (this.props.onSent) {
                            return this.props.onSent(model).then(() => {
                                this.setState({ isSendButtonEnabled: true });
                                appStore.workflowStore.setLoading(false);
                            });
                        } else {
                            appStore.workflowStore.setLoading(false);
                            this.setState({ isSendButtonEnabled: true });
                        }
                    })
                    .catch((err) => {
                        if (emailSent) {
                            Rollbar.error('Email sent successfully, but step cannot be "completed".', err);
                            Notifications.ToastError('Email sent successfully, but step cannot be "completed".');
                        } else {
                            Rollbar.error('There was an error sending your email.', err);
                            Notifications.ToastError('There was an error sending your email.');
                        }
                    });
            } else {
                // this.props.appStore.analytics.track('Workflow Step Submitted',
                //     {step: this.props.step, values: this.form.values(), valid: false, errors: form.errors()})

                const errorMessages = _.filter(form.errors(), (value) => {
                    return !_.isUndefined(value);
                });
                Notifications.ToastError(errorMessages);
            }
        });
    }

    updateEmailModelFromDraft() {
        this.sendEmailStore.emailModel = _.clone(this.props.model);
    }

    handleOnChangeEvent(files) {
        this.sendEmailStore.setAttached(files);
    }

    generateUniqueKeyFromProps(props) {
        const selectedTemplate = this.sendEmailStore.selectedTemplate
                ? this.sendEmailStore.selectedTemplate.id
                : props.templateId,
            timelineGeneratedDate = props.timelineGeneratedDate || 'no-timeline',
            toEmails = props.toEmails ? props.toEmails.map((email) => email.email).join(',') : 'no-emails';
        return selectedTemplate + timelineGeneratedDate + toEmails;
    }

    componentWillMount() {
        this.form.clear();
        this.setState({ editorId: uuid.v4() });
        when(
            () => {
                return this.emailTemplateStore.templates.length > 0;
            },
            () => {
                this.sendEmailStore.loadAndFilterTemplates(this.emailTemplateStore.templates, this.props.template);
                if (this.props.model) {
                    this.sendEmailStore.selectedTemplate = this.sendEmailStore.templates.find(
                        (template) => template.id === this.props.draftTemplateId
                    );
                    this.updateEmailModelFromDraft();
                    this.updateFormFromModel();
                } else {
                    this.updateUI(this.props);
                }
            }
        );
        if (
            this.props.step.type === 'send-invoice' &&
            this.props.invoiceData &&
            this.props.invoiceData.invoiceFileData
        ) {
            this.setState({ isSendInvoice: true });
            let attachment = {};
            let file = {};
            file.name = this.props.invoiceData.invoiceFileData.filename;
            file.type = 'application/pdf';
            attachment.file = file;
            attachment.publicUrl = `/s3/uploads/${this.props.invoiceData.invoiceFileData.fileKey}`;
            attachment.fileKey = this.props.invoiceData.invoiceFileData.fileKey;
            attachment.signedUrl = this.props.invoiceData.invoiceFileData.signedUrl;
            attachment.filename = this.props.invoiceData.invoiceFileData.fileKey;
            this.setState({ invoice: attachment });
        } else {
            this.setState({ isSendInvoice: false });
        }
    }

    componentDidMount() {
        if (this.props.onEmailModelChange) {
            this.form.$('toEmails').observe(({ form, field, change }) => {
                if (this.propagateChanges) this.handleFormChange();
            });
            this.form.$('ccEmails').observe(({ form, field, change }) => {
                if (this.propagateChanges) this.handleFormChange();
            });
            this.form.$('bccEmails').observe(({ form, field, change }) => {
                if (this.propagateChanges) this.handleFormChange();
            });
            this.form.$('subject').observe(
                _.debounce(
                    () => {
                        if (this.propagateChanges) this.handleFormChange();
                    },
                    1500,
                    { maxWait: 3000 }
                )
            );
        }
    }

    componentWillReceiveProps(nextProps) {
        const hasPropsChanged =
            this.generateUniqueKeyFromProps(this.props) !== this.generateUniqueKeyFromProps(nextProps);
        if (hasPropsChanged) {
            this.propagateChanges = false;
            this.updateUI(nextProps);
            this.propagateChanges = true;
        }
    }

    renderCompleteView(model, sentDate) {
        const attachedFiles =
            model.attachments && model.attachments.length > 0 ? (
                <div className="attachments">
                    {_.map(model.attachments, (attachment) => {
                        return (
                            <div className="xs-col-6">
                                <S3DownloadButton bsStyle="link" fileKey={attachment.fileKey}>
                                    {attachment.file.name}
                                </S3DownloadButton>
                            </div>
                        );
                    })}
                </div>
            ) : null;

        return (
            <div className={`email-step`}>
                <div className="row email">
                    <div className="col-xs-12 col-sm-12">
                        <h4>{`Email was sent on ${moment(sentDate).format('L LT')}`}</h4>
                    </div>

                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">To:</span> <span>{model.toEmails.join(', ')} </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">Cc:</span>
                        <span> {model.ccEmails.join(', ')} </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">Bcc:</span> <span>{model.bccEmails.join(', ')} </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">From:</span>
                        <span> {model.fromEmail} </span>
                    </div>
                    <hr className="section-header" />
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">Subject:</span>
                        <span> {model.subject} </span>
                    </div>
                    <hr className="section-header" />
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <div className="body" dangerouslySetInnerHTML={{ __html: model.body }}></div>
                    </div>
                    <div className="col-xs-12 col-sm-12">{attachedFiles}</div>
                </div>
            </div>
        );
    }

    renderIncompleteView() {
        const currentUser = this.props.appStore.coordinatorDetailStore.coordinator,
            uniqueKeyFromProps = this.generateUniqueKeyFromProps(this.props);

        return this.props.isHidden ? null : (
            <div className="workflow">
                {currentUser.hasGoogleCredentials ? (
                    <div className="row">
                        <form key={`emailstep-1`} className="form-horizontal form" style={{ paddingBottom: '12px' }}>
                            {/**Template*/}
                            <div className="col-xs-12 col-sm-12 field" style={{ marginBottom: 20 }}>
                                <h6>Template</h6>
                                <hr className="section-header" />
                                <select
                                    id="selectedTemplate"
                                    className="form-control"
                                    value={
                                        this.sendEmailStore.selectedTemplate
                                            ? this.sendEmailStore.selectedTemplate.id
                                            : null
                                    }
                                    onChange={this.handleTemplateChange.bind(this)}
                                >
                                    {this.sendEmailStore.templates.map((template) => {
                                        return (
                                            <option key={template.id} value={template.id}>
                                                {template.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            <div className="col-xs-12 col-sm-12 field" style={{ marginBottom: 20 }}>
                                {this.state.missingContacts.map((error) => {
                                    return <p className="form-error">{error}</p>;
                                })}
                            </div>

                            {/**TO*/}
                            <div className="col-xs-12 col-sm-12 field">
                                <h6>Email Headers</h6>
                                <hr className="section-header" />
                                <div className="form-group">
                                    <label
                                        className="col-sm-2 col-md-1 control-label"
                                        htmlFor={this.form.$(`toEmails`).id}
                                    >
                                        {this.form.$(`toEmails`).label}
                                    </label>
                                    <div className="col-sm-10 col-md-11">
                                        <TagsInput
                                            addKeys={[9, 13, 188, 32]}
                                            {...this.form.$('toEmails').bind()}
                                            onlyUnique
                                            addOnPaste
                                            inputProps={{ placeholder: 'Add an Email' }}
                                            validationRegex={EMAIL_VALIDATION_REGEX}
                                            onValidationReject={this.handleValidationError.bind(this)}
                                            pasteSplit={(data) => {
                                                return data
                                                    .replace(/[\r\n,;]/g, ' ')
                                                    .split(' ')
                                                    .map((d) => d.trim());
                                            }}
                                        />
                                        <p className="form-error">{this.form.$(`toEmails`).error}</p>
                                    </div>
                                </div>
                            </div>

                            {/**CC Emails*/}
                            <div className="col-xs-12 col-sm-12 field">
                                <div className="form-group">
                                    <label
                                        className="col-sm-2 col-md-1 control-label"
                                        htmlFor={this.form.$(`ccEmails`).id}
                                    >
                                        {this.form.$(`ccEmails`).label}
                                    </label>
                                    <div className="col-sm-10 col-md-11">
                                        <TagsInput
                                            addKeys={[9, 13, 188, 32]}
                                            placeholder="Add Email"
                                            {...this.form.$('ccEmails').bind()}
                                            onlyUnique
                                            addOnPaste
                                            inputProps={{ placeholder: 'Add an Email' }}
                                            validationRegex={EMAIL_VALIDATION_REGEX}
                                            onValidationReject={this.handleValidationError.bind(this)}
                                            pasteSplit={(data) => {
                                                return data
                                                    .replace(/[\r\n,;]/g, ' ')
                                                    .split(' ')
                                                    .map((d) => d.trim());
                                            }}
                                        />
                                        <p className="form-error">{this.form.$(`ccEmails`).error}</p>
                                    </div>
                                </div>
                            </div>
                            {/**BCC Emails*/}
                            <div className="col-xs-12 col-sm-12 field">
                                <div className="form-group">
                                    <label
                                        className="col-sm-2 col-md-1 control-label"
                                        htmlFor={this.form.$(`bccEmails`).id}
                                    >
                                        {this.form.$(`bccEmails`).label}
                                    </label>
                                    <div className="col-sm-10 col-md-11">
                                        <TagsInput
                                            addKeys={[9, 13, 188, 32]}
                                            placeholder="Add Email"
                                            {...this.form.$('bccEmails').bind()}
                                            onlyUnique
                                            addOnPaste
                                            inputProps={{ placeholder: 'Add an Email' }}
                                            validationRegex={EMAIL_VALIDATION_REGEX}
                                            onValidationReject={this.handleValidationError.bind(this)}
                                            pasteSplit={(data) => {
                                                return data
                                                    .replace(/[\r\n,;]/g, ' ')
                                                    .split(' ')
                                                    .map((d) => d.trim());
                                            }}
                                        />
                                        <p className="form-error">{this.form.$(`bccEmails`).error}</p>
                                    </div>
                                </div>
                            </div>
                            {/**FROM*/}
                            <div className="col-xs-12 col-sm-12 field">
                                <div className="form-group">
                                    <label
                                        className="col-sm-2 col-md-1 control-label"
                                        htmlFor={this.form.$(`fromEmail`).id}
                                    >
                                        {this.form.$(`fromEmail`).label}
                                    </label>
                                    <div className="col-sm-10 col-md-11">
                                        <input
                                            id={this.form.$(`fromEmail`).id}
                                            className="form-control"
                                            {...this.form.$(`fromEmail`).bind()}
                                        />
                                        <p className="form-error">{this.form.$(`fromEmail`).error}</p>
                                    </div>
                                </div>
                            </div>
                            {/**Subject*/}
                            <div className="col-xs-12 col-sm-12 field">
                                <div className="form-group">
                                    <label
                                        className="col-sm-2 col-md-1 control-label"
                                        htmlFor={this.form.$(`subject`).id}
                                    >
                                        {this.form.$(`subject`).label}
                                    </label>
                                    <div className="col-sm-10 col-md-11">
                                        <input
                                            id={this.form.$(`subject`).id}
                                            className="form-control"
                                            {...this.form.$(`subject`).bind()}
                                        />
                                        <p className="form-error">{this.form.$(`subject`).error}</p>
                                    </div>
                                </div>
                            </div>
                            {this.props.onEmailModelChange ? (
                                <div className="col-xs-12 col-sm-12" style={{ marginBottom: 5, marginTop: 5 }}>
                                    {this.props.isSaving ? (
                                        <span className="text-success pull-right" style={{ fontSize: 18 }}>
                                            Saving....
                                        </span>
                                    ) : null}
                                    {this.props.isSaved ? (
                                        <span className="text-success  pull-right" style={{ fontSize: 18 }}>
                                            Saved
                                        </span>
                                    ) : null}
                                </div>
                            ) : null}
                            {/**Body*/}
                            <div className="col-xs-12 col-sm-12" style={{ marginBottom: 20 }}>
                                <div className="form-group">
                                    <Editor
                                        container="editable"
                                        data={this.sendEmailStore.emailModel.body}
                                        uniqueKeyFromProps={uniqueKeyFromProps} //Based on template,contacts, and typeOfsale
                                        onReady={() => {
                                            this.readyForChanges = true;
                                            this.propagateChanges = true;
                                        }}
                                        handleFormChange={_.debounce(
                                            () => {
                                                if (this.propagateChanges) this.handleFormChange();
                                            },
                                            1500,
                                            { maxWait: 3000 }
                                        )}
                                        editorId={this.state.editorId}
                                        ref="skytcSendEmailEditor"
                                    />
                                </div>
                            </div>
                            <div className="col-xs-12 field" style={{ marginBottom: 16 }}>
                                <AttachedFilesComponent
                                    attachments={this.props.model ? this.props.model.attachments : []}
                                    onChangeEvent={this.handleOnChangeEvent.bind(this)}
                                    invoiceData={this.props.invoiceData}
                                >
                                    {' '}
                                </AttachedFilesComponent>
                            </div>
                        </form>
                        <div className="col-md-12">
                            <button
                                type="button"
                                className="btn btn-primary pull-right"
                                disabled={!this.state.isSendButtonEnabled}
                                onClick={this.handleSend.bind(this)}
                            >
                                Send
                            </button>
                            {!this.cancelHandler && this.props.hasCancelHandler ? (
                                <button
                                    type="button"
                                    className="btn btn-default pull-right"
                                    style={{ marginRight: 10 }}
                                    onClick={this.props.cancelHandler}
                                >
                                    Cancel
                                </button>
                            ) : null}
                        </div>
                    </div>
                ) : (
                    <span>
                        Please <a href={`/link/google?id=${currentUser.coordinatorId}`}>link</a> your Google Account{' '}
                    </span>
                )}
            </div>
        );
    }

    render() {
        return this.props.isComplete
            ? this.renderCompleteView(this.props.model, this.props.sentDate)
            : this.renderIncompleteView();
    }
}
SendEmail.propTypes = {
    cancelHandler: PropTypes.func,
    onEmailModelChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/send-email-component.js